import { Pipe, PipeTransform } from '@angular/core';
import { PaginationOptions } from '../models/tipologiche/pagination-options';

@Pipe({
    name: 'pagination',
    pure: false
})

export class PaginationPipe implements PipeTransform {
    
    transform(items: any[], options: PaginationOptions): any[] {
        if(!items || !options) {
            return items;
        }

        let fromIndex = (options.getCurrentPage() - 1) * options.getItemsPerPage();
        let toIndex = options.getCurrentPage() * options.getItemsPerPage();

        return items.filter((item, index) => index >= fromIndex && index < toIndex);

    }

}